
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Parts extends Vue {
  @Prop({ type: String, default: 'none' })
  public status!: string;

  private get stroke1(): string {
    if (this.status === 'mask') return '#000000';
    if (this.status === 'capture') return 'var(--shooting-auto-frame-color-before)';
    if (this.status === 'success') return 'var(--shooting-autog-frame-color-after)';
    return '#ffffff';
  }

  private get stroke2(): string {
    if (this.status === 'mask') return '#000000';
    return '#ffffff';
  }

  private get fillMask(): string {
    if (this.status === 'mask') return '#000000';
    return 'transparent';
  }
}
